/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const requestContext = /* GraphQL */ `
  query RequestContext {
    requestContext {
      environment
      appMessage
      appMessageColor
      latestDashboardVersion
      __typename
    }
  }
`;
export const getPLResident = /* GraphQL */ `
  query GetPLResident($input: PLResidentInput!) {
    getPLResident(input: $input) {
      payLeaseResident
      __typename
    }
  }
`;
export const retrievePLRequestToken = /* GraphQL */ `
  query RetrievePLRequestToken($input: PLRequestTokenInput!) {
    retrievePLRequestToken(input: $input) {
      requestToken
      __typename
    }
  }
`;
export const getAmenityDetails = /* GraphQL */ `
  query GetAmenityDetails($input: CommonRequestInput!) {
    getAmenityDetails(input: $input) {
      id
      buildingId
      label
      description
      rules
      mustAgreeToRules
      ignoreBookInAdvanceForStaff
      needsApproval
      weeklyReservationLimit
      attachments {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      isVisible
      advancedNoticeCancel
      advancedNoticeRequest
      minReservationDuration
      maxReservationDuration
      maxPartySize
      maxOccupancy
      maxConcurrentReservations
      reservationPadding
      reservationIncrement
      closures {
        id
        resourceId
        label
        startAt
        endAt
        __typename
      }
      generalAvailability {
        id
        resourceId
        dayOfWeek
        startTime
        endTime
        __typename
      }
      isOnboardingOnly
      requiresPayment
      depositPrice
      hourlyPrice
      amenityType
      __typename
    }
  }
`;
export const getAmenityDetailsBatch = /* GraphQL */ `
  query GetAmenityDetailsBatch($input: CommonRequestBatchInput!) {
    getAmenityDetailsBatch(input: $input) {
      batch {
        id
        buildingId
        label
        description
        rules
        mustAgreeToRules
        ignoreBookInAdvanceForStaff
        needsApproval
        weeklyReservationLimit
        isVisible
        advancedNoticeCancel
        advancedNoticeRequest
        minReservationDuration
        maxReservationDuration
        maxPartySize
        maxOccupancy
        maxConcurrentReservations
        reservationPadding
        reservationIncrement
        isOnboardingOnly
        requiresPayment
        depositPrice
        hourlyPrice
        amenityType
        __typename
      }
      __typename
    }
  }
`;
export const getAmenityCalendar = /* GraphQL */ `
  query GetAmenityCalendar($input: GetAmenityCalendarInput!) {
    getAmenityCalendar(input: $input) {
      id
      buildingId
      label
      description
      rules
      mustAgreeToRules
      needsApproval
      weeklyReservationLimit
      attachments {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      minReservationDuration
      maxReservationDuration
      maxPartySize
      reservationPadding
      reservationIncrement
      availability {
        start
        end
        __typename
      }
      generalAvailability {
        id
        resourceId
        dayOfWeek
        startTime
        endTime
        __typename
      }
      __typename
    }
  }
`;
export const getVendorServiceAvailability = /* GraphQL */ `
  query GetVendorServiceAvailability(
    $input: GetVendorServiceAvailabilityInput!
  ) {
    getVendorServiceAvailability(input: $input) {
      id
      buildingId
      label
      type
      subType
      price
      duration
      availability {
        start
        end
        __typename
      }
      __typename
    }
  }
`;
export const getVendorServiceResourceSettings = /* GraphQL */ `
  query GetVendorServiceResourceSettings($input: CommonRequestInput!) {
    getVendorServiceResourceSettings(input: $input) {
      id
      foreignServiceId
      closures {
        id
        resourceId
        label
        startAt
        endAt
        __typename
      }
      generalAvailability {
        id
        resourceId
        dayOfWeek
        startTime
        endTime
        __typename
      }
      __typename
    }
  }
`;
export const getSmartHubUserProfile = /* GraphQL */ `
  query GetSmartHubUserProfile {
    getSmartHubUserProfile {
      id
      email
      firstName
      lastName
      mobilePhone
      tosAcceptedAt
      userNeedsToAcceptTOS
      __typename
    }
  }
`;
export const getSmartHubDevices = /* GraphQL */ `
  query GetSmartHubDevices($input: GetSmartHubDevicesInput!) {
    getSmartHubDevices(input: $input) {
      devices {
        ... on SmartHubThermostat {
          id
          type
          displayName
          batteryLevel
          updatedAt
          isOnline
          currentTemp
          coolingSetpoint
          heatingSetpoint
          currentHumidity
          mode
          fanMode
        }
        ... on SmartHubLock {
          id
          type
          displayName
          batteryLevel
          updatedAt
          isOnline
          isLocked
          pinCode
          validPinCodeLengths
        }
        ... on SmartHubLight {
          id
          type
          displayName
          batteryLevel
          updatedAt
          isOnline
          isOn
        }
        ... on SmartHubLeakSensor {
          id
          type
          displayName
          batteryLevel
          updatedAt
          isOnline
          hasLeak
        }
        ... on SmartHubDimmerLight {
          id
          type
          displayName
          batteryLevel
          updatedAt
          isOnline
          level
        }
      }
      __typename
    }
  }
`;
export const getSmartHubDevice = /* GraphQL */ `
  query GetSmartHubDevice($input: GetSmartHubDeviceInput!) {
    getSmartHubDevice(input: $input) {
      ... on SmartHubThermostat {
        id
        type
        displayName
        batteryLevel
        updatedAt
        isOnline
        currentTemp
        coolingSetpoint
        heatingSetpoint
        currentHumidity
        mode
        fanMode
      }
      ... on SmartHubLock {
        id
        type
        displayName
        batteryLevel
        updatedAt
        isOnline
        isLocked
        pinCode
        validPinCodeLengths
      }
      ... on SmartHubLight {
        id
        type
        displayName
        batteryLevel
        updatedAt
        isOnline
        isOn
      }
      ... on SmartHubLeakSensor {
        id
        type
        displayName
        batteryLevel
        updatedAt
        isOnline
        hasLeak
      }
      ... on SmartHubDimmerLight {
        id
        type
        displayName
        batteryLevel
        updatedAt
        isOnline
        level
      }
    }
  }
`;
export const getSmartHubDeviceActivity = /* GraphQL */ `
  query GetSmartHubDeviceActivity($input: GetSmartHubDeviceActivityInput!) {
    getSmartHubDeviceActivity(input: $input) {
      activity {
        id
        deviceId
        type
        label
        date
        __typename
      }
      __typename
    }
  }
`;
export const getSmartHubAuthorizationUrl = /* GraphQL */ `
  query GetSmartHubAuthorizationUrl {
    getSmartHubAuthorizationUrl {
      url
      __typename
    }
  }
`;
export const getSocialEventRegistrants = /* GraphQL */ `
  query GetSocialEventRegistrants($input: GetSocialEventRegistrantsInput!) {
    getSocialEventRegistrants(input: $input) {
      registrants {
        residentId
        residentDisplayName
        partySize
        socialEventResponseId
        createdAt
        __typename
      }
      __typename
    }
  }
`;
export const listStaffAtBuilding = /* GraphQL */ `
  query ListStaffAtBuilding($buildingId: ID!) {
    listStaffAtBuilding(buildingId: $buildingId) {
      id
      phoneNumber
      userName
      passwordResetMeta
      displayName
      permissionGroup
      buildings {
        nextToken
        __typename
      }
      messages {
        nextToken
        __typename
      }
      notificationSettings {
        nextToken
        __typename
      }
      profileImage {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      dateClaimed
      lastLoggedInAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const messageContentSearch = /* GraphQL */ `
  query MessageContentSearch(
    $input: MessageContentSearchInput!
    $limit: Int
    $nextToken: String
  ) {
    messageContentSearch(input: $input, limit: $limit, nextToken: $nextToken) {
      messages {
        id
        createdAt
        messageConversationId
        messageStaffId
        recipient
        body
        type
        topic
        updatedAt
        __typename
      }
      chatMessages {
        id
        chatRoomId
        chatParticipantId
        content
        isAttachments
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBuilding = /* GraphQL */ `
  query GetBuilding($id: ID!) {
    getBuilding(id: $id) {
      id
      displayName
      yardiId
      oscarId
      units {
        nextToken
        __typename
      }
      staff {
        nextToken
        __typename
      }
      documents {
        nextToken
        __typename
      }
      events {
        nextToken
        __typename
      }
      cleaningPrices {
        nextToken
        __typename
      }
      announcements {
        nextToken
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      partners {
        nextToken
        __typename
      }
      amenities {
        nextToken
        __typename
      }
      email
      streetAddress
      city
      state
      zipCode
      website
      phoneNumber
      officeHours
      deskHours {
        __typename
      }
      deskHoursEnabled
      disabledFeatures
      socialLinks
      emergencyMaintenancePhoneNumber
      taxRate
      outOfOfficeStatus
      freeCleaningOffering
      launchDate
      supportEmail
      lastSyncedYardi
      lastSyncedOscar
      leaseRenewalURL
      supportFormURL
      timezone
      outOfOfficeMessage
      onboardingSchema
      smartHubLaunchDate
      leaveAReviewURL
      organizationId
      organization {
        id
        displayName
        ownerIds
        documentTags
        createdAt
        updatedAt
        __typename
      }
      dummyResidentId
      dummyResident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      sisterBuildings {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBuildings = /* GraphQL */ `
  query ListBuildings(
    $filter: ModelBuildingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSisterBuilding = /* GraphQL */ `
  query GetSisterBuilding($id: ID!) {
    getSisterBuilding(id: $id) {
      id
      primaryBuildingId
      primaryBuilding {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      sisterBuildingId
      sisterBuilding {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSisterBuildings = /* GraphQL */ `
  query ListSisterBuildings(
    $filter: ModelSisterBuildingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSisterBuildings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        primaryBuildingId
        sisterBuildingId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      displayName
      ownerIds
      documents {
        nextToken
        __typename
      }
      documentTags
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        displayName
        ownerIds
        documentTags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocument = /* GraphQL */ `
  query GetDocument($id: ID!) {
    getDocument(id: $id) {
      id
      organizationId
      buildings {
        nextToken
        __typename
      }
      internalName
      displayName
      file {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      coverImage {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      category
      documentTags
      residentGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments(
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationId
        internalName
        displayName
        category
        documentTags
        residentGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBuildingDocument = /* GraphQL */ `
  query GetBuildingDocument($id: ID!) {
    getBuildingDocument(id: $id) {
      id
      buildingId
      documentId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      document {
        id
        organizationId
        internalName
        displayName
        category
        documentTags
        residentGroups
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBuildingDocuments = /* GraphQL */ `
  query ListBuildingDocuments(
    $filter: ModelBuildingDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        documentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAnnouncement = /* GraphQL */ `
  query GetAnnouncement($id: ID!) {
    getAnnouncement(id: $id) {
      id
      activeStart
      activeEnd
      headline
      text
      htmlText
      announcementsBuildingId
      staffId
      attachments {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      images {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      audienceLabel
      residents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnnouncements = /* GraphQL */ `
  query ListAnnouncements(
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnnouncements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        activeStart
        activeEnd
        headline
        text
        htmlText
        announcementsBuildingId
        staffId
        audienceLabel
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResidentAnnouncement = /* GraphQL */ `
  query GetResidentAnnouncement($id: ID!) {
    getResidentAnnouncement(id: $id) {
      id
      announcementId
      announcement {
        id
        activeStart
        activeEnd
        headline
        text
        htmlText
        announcementsBuildingId
        staffId
        audienceLabel
        createdAt
        updatedAt
        __typename
      }
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      readAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listResidentAnnouncements = /* GraphQL */ `
  query ListResidentAnnouncements(
    $filter: ModelResidentAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResidentAnnouncements(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        announcementId
        residentId
        readAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAppEngagement = /* GraphQL */ `
  query GetAppEngagement($id: ID!) {
    getAppEngagement(id: $id) {
      id
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      entityType
      entityId
      action
      createdAt
      meta
      updatedAt
      __typename
    }
  }
`;
export const listAppEngagements = /* GraphQL */ `
  query ListAppEngagements(
    $filter: ModelAppEngagementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppEngagements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        residentId
        entityType
        entityId
        action
        createdAt
        meta
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getChatRoom = /* GraphQL */ `
  query GetChatRoom($id: ID!) {
    getChatRoom(id: $id) {
      id
      displayName
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      status
      lastChatMessageId
      lastChatMessage {
        id
        chatRoomId
        chatParticipantId
        content
        isAttachments
        createdAt
        updatedAt
        __typename
      }
      chatMessages {
        nextToken
        __typename
      }
      chatParticipants {
        nextToken
        __typename
      }
      participantIds
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listChatRooms = /* GraphQL */ `
  query ListChatRooms(
    $filter: ModelChatRoomFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatRooms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        displayName
        buildingId
        status
        lastChatMessageId
        participantIds
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getChatParticipant = /* GraphQL */ `
  query GetChatParticipant($id: ID!) {
    getChatParticipant(id: $id) {
      id
      chatRoomId
      chatRoom {
        id
        displayName
        buildingId
        status
        lastChatMessageId
        participantIds
        createdAt
        updatedAt
        __typename
      }
      participantId
      displayName
      isStaffParticipant
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listChatParticipants = /* GraphQL */ `
  query ListChatParticipants(
    $filter: ModelChatParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatParticipants(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chatRoomId
        participantId
        displayName
        isStaffParticipant
        lastSeenAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOnboardingTask = /* GraphQL */ `
  query GetOnboardingTask($id: ID!) {
    getOnboardingTask(id: $id) {
      id
      occupancyId
      dependsOn
      state
      requiresApproval
      importance
      supportsMultipleSubmissions
      label
      key
      form
      taskMeta
      createdAt
      updatedAt
      stateHistory {
        state
        previousState
        modifiedBy
        timestamp
        __typename
      }
      __typename
    }
  }
`;
export const listOnboardingTasks = /* GraphQL */ `
  query ListOnboardingTasks(
    $filter: ModelOnboardingTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOnboardingTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        occupancyId
        dependsOn
        state
        requiresApproval
        importance
        supportsMultipleSubmissions
        label
        key
        form
        taskMeta
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGuest = /* GraphQL */ `
  query GetGuest($id: ID!) {
    getGuest(id: $id) {
      id
      firstName
      lastName
      registrationExpiry
      meetingOption
      instructions
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      unitId
      unit {
        id
        number
        unitBuildingId
        sqft
        bedrooms
        bathrooms
        createdAt
        updatedAt
        __typename
      }
      isDeleted
      guestVisits {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGuests = /* GraphQL */ `
  query ListGuests(
    $filter: ModelGuestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        registrationExpiry
        meetingOption
        instructions
        residentId
        buildingId
        unitId
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGuestVisit = /* GraphQL */ `
  query GetGuestVisit($id: ID!) {
    getGuestVisit(id: $id) {
      id
      createdAt
      isPermanent
      guestName
      residentName
      unitNumber
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      guestId
      guest {
        id
        firstName
        lastName
        registrationExpiry
        meetingOption
        instructions
        residentId
        buildingId
        unitId
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listGuestVisits = /* GraphQL */ `
  query ListGuestVisits(
    $filter: ModelGuestVisitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuestVisits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        isPermanent
        guestName
        residentName
        unitNumber
        buildingId
        guestId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotificationSetting = /* GraphQL */ `
  query GetNotificationSetting($id: ID!) {
    getNotificationSetting(id: $id) {
      id
      category
      medium
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      isUnsubscribed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNotificationSettings = /* GraphQL */ `
  query ListNotificationSettings(
    $filter: ModelNotificationSettingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        category
        medium
        residentId
        isUnsubscribed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEnqueuedNotification = /* GraphQL */ `
  query GetEnqueuedNotification($id: ID!) {
    getEnqueuedNotification(id: $id) {
      id
      entityKey
      medium
      payload
      addresses
      sendAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEnqueuedNotifications = /* GraphQL */ `
  query ListEnqueuedNotifications(
    $filter: ModelEnqueuedNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEnqueuedNotifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityKey
        medium
        payload
        addresses
        sendAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDelivery = /* GraphQL */ `
  query GetDelivery($id: ID!) {
    getDelivery(id: $id) {
      id
      trackingNumber
      carrier
      packageType
      priority
      notes
      createdAt
      receivedAt
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      unitId
      unit {
        id
        number
        unitBuildingId
        sqft
        bedrooms
        bathrooms
        createdAt
        updatedAt
        __typename
      }
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      deliveredDetails {
        deliveredTo
        staffId
        recipientName
        __typename
      }
      isDeleted
      staffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listDeliverys = /* GraphQL */ `
  query ListDeliverys(
    $filter: ModelDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliverys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        trackingNumber
        carrier
        packageType
        priority
        notes
        createdAt
        receivedAt
        residentId
        unitId
        buildingId
        isDeleted
        staffId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeliveryArchive = /* GraphQL */ `
  query GetDeliveryArchive($id: ID!) {
    getDeliveryArchive(id: $id) {
      id
      trackingNumber
      carrier
      packageType
      priority
      notes
      createdAt
      receivedAt
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      unitId
      unit {
        id
        number
        unitBuildingId
        sqft
        bedrooms
        bathrooms
        createdAt
        updatedAt
        __typename
      }
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      deliveredDetails {
        deliveredTo
        staffId
        recipientName
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listDeliveryArchives = /* GraphQL */ `
  query ListDeliveryArchives(
    $filter: ModelDeliveryArchiveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliveryArchives(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        trackingNumber
        carrier
        packageType
        priority
        notes
        createdAt
        receivedAt
        residentId
        unitId
        buildingId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOutgoingDelivery = /* GraphQL */ `
  query GetOutgoingDelivery($id: ID!) {
    getOutgoingDelivery(id: $id) {
      id
      carrier
      packageType
      createdAt
      shippedAt
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      unitId
      unit {
        id
        number
        unitBuildingId
        sqft
        bedrooms
        bathrooms
        createdAt
        updatedAt
        __typename
      }
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      trackingNumber
      notes
      isDeleted
      staffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listOutgoingDeliverys = /* GraphQL */ `
  query ListOutgoingDeliverys(
    $filter: ModelOutgoingDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutgoingDeliverys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        carrier
        packageType
        createdAt
        shippedAt
        residentId
        unitId
        buildingId
        trackingNumber
        notes
        isDeleted
        staffId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIntegratedDelivery = /* GraphQL */ `
  query GetIntegratedDelivery($id: ID!) {
    getIntegratedDelivery(id: $id) {
      id
      integrationName
      integrationId
      deliveryId
      delivery {
        id
        trackingNumber
        carrier
        packageType
        priority
        notes
        createdAt
        receivedAt
        residentId
        unitId
        buildingId
        isDeleted
        staffId
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIntegratedDeliverys = /* GraphQL */ `
  query ListIntegratedDeliverys(
    $filter: ModelIntegratedDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegratedDeliverys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        integrationName
        integrationId
        deliveryId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPartner = /* GraphQL */ `
  query GetPartner($id: ID!) {
    getPartner(id: $id) {
      id
      displayName
      description
      shortDescription
      callToAction
      coverImage {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      logo {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      landingUrl
      email
      phoneNumber
      order
      buildings {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPartners = /* GraphQL */ `
  query ListPartners(
    $filter: ModelPartnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPartners(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        displayName
        description
        shortDescription
        callToAction
        landingUrl
        email
        phoneNumber
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBuildingPartner = /* GraphQL */ `
  query GetBuildingPartner($id: ID!) {
    getBuildingPartner(id: $id) {
      id
      partnerId
      partner {
        id
        displayName
        description
        shortDescription
        callToAction
        landingUrl
        email
        phoneNumber
        order
        createdAt
        updatedAt
        __typename
      }
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      isFeatured
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBuildingPartners = /* GraphQL */ `
  query ListBuildingPartners(
    $filter: ModelBuildingPartnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingPartners(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        partnerId
        buildingId
        isFeatured
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBuildingStaff = /* GraphQL */ `
  query GetBuildingStaff($id: ID!) {
    getBuildingStaff(id: $id) {
      id
      buildingId
      staffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      isDisabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBuildingStaffs = /* GraphQL */ `
  query ListBuildingStaffs(
    $filter: ModelBuildingStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingStaffs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        buildingId
        staffId
        isDisabled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSocialEvent = /* GraphQL */ `
  query GetSocialEvent($id: ID!) {
    getSocialEvent(id: $id) {
      id
      eventName
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      socialEventBuildingId
      startTime
      endTime
      previewDescription
      description
      htmlDescription
      payRequired
      pricePerPerson
      rsvpRequired
      capacity
      location
      image {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      images {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      attachments {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      headcount
      allowResidentsToViewRsvps
      allowResidentGuestRsvps
      allowWaitlist
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSocialEvents = /* GraphQL */ `
  query ListSocialEvents(
    $filter: ModelSocialEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSocialEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventName
        socialEventBuildingId
        startTime
        endTime
        previewDescription
        description
        htmlDescription
        payRequired
        pricePerPerson
        rsvpRequired
        capacity
        location
        headcount
        allowResidentsToViewRsvps
        allowResidentGuestRsvps
        allowWaitlist
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSocialEventResponse = /* GraphQL */ `
  query GetSocialEventResponse($id: ID!) {
    getSocialEventResponse(id: $id) {
      id
      socialEventId
      residentId
      partySize
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSocialEventResponses = /* GraphQL */ `
  query ListSocialEventResponses(
    $filter: ModelSocialEventResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSocialEventResponses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        socialEventId
        residentId
        partySize
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCleaningPrice = /* GraphQL */ `
  query GetCleaningPrice($id: ID!) {
    getCleaningPrice(id: $id) {
      id
      cleaningPriceBuildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      bedrooms
      bathrooms
      baseSqFt
      service
      price
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCleaningPrices = /* GraphQL */ `
  query ListCleaningPrices(
    $filter: ModelCleaningPriceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCleaningPrices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cleaningPriceBuildingId
        bedrooms
        bathrooms
        baseSqFt
        service
        price
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUnit = /* GraphQL */ `
  query GetUnit($id: ID!) {
    getUnit(id: $id) {
      id
      number
      unitBuildingId
      sqft
      bedrooms
      bathrooms
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      occupancies {
        nextToken
        __typename
      }
      guests {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUnits = /* GraphQL */ `
  query ListUnits(
    $filter: ModelUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        number
        unitBuildingId
        sqft
        bedrooms
        bathrooms
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUnitTag = /* GraphQL */ `
  query GetUnitTag($id: ID!) {
    getUnitTag(id: $id) {
      id
      buildingId
      label
      units {
        nextToken
        __typename
      }
      metaNumbers
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUnitTags = /* GraphQL */ `
  query ListUnitTags(
    $filter: ModelUnitTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnitTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        buildingId
        label
        metaNumbers
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUnitTagUnit = /* GraphQL */ `
  query GetUnitTagUnit($id: ID!) {
    getUnitTagUnit(id: $id) {
      id
      unitId
      unit {
        id
        number
        unitBuildingId
        sqft
        bedrooms
        bathrooms
        createdAt
        updatedAt
        __typename
      }
      unitTagId
      unitTag {
        id
        buildingId
        label
        metaNumbers
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUnitTagUnits = /* GraphQL */ `
  query ListUnitTagUnits(
    $filter: ModelUnitTagUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnitTagUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        unitId
        unitTagId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOccupancy = /* GraphQL */ `
  query GetOccupancy($id: ID!) {
    getOccupancy(id: $id) {
      id
      createdAt
      status
      leaseFromDate
      occupancyUnitId
      unit {
        id
        number
        unitBuildingId
        sqft
        bedrooms
        bathrooms
        createdAt
        updatedAt
        __typename
      }
      yardiId
      residents {
        nextToken
        __typename
      }
      cleaningRequests {
        nextToken
        __typename
      }
      disabledFeatures
      ledgerItems {
        chargeId
        chargeDate
        chargeCode
        amount
        label
        description
        __typename
      }
      mustUpdateLedger
      isRentSuspended
      leaseToDate
      onboardingTasks {
        nextToken
        __typename
      }
      onboardingMeta
      ledgerLastUpdatedAt
      isUnitTransfer
      isAffordable
      updatedAt
      __typename
    }
  }
`;
export const listOccupancys = /* GraphQL */ `
  query ListOccupancys(
    $filter: ModelOccupancyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOccupancys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        status
        leaseFromDate
        occupancyUnitId
        yardiId
        disabledFeatures
        mustUpdateLedger
        isRentSuspended
        leaseToDate
        onboardingMeta
        ledgerLastUpdatedAt
        isUnitTransfer
        isAffordable
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPaymentMethod = /* GraphQL */ `
  query GetPaymentMethod($id: ID!) {
    getPaymentMethod(id: $id) {
      id
      nickName
      payerReferenceId
      payerSecondaryRefId
      gatewayPayerId
      payerReferenceIdLabs
      gatewayPayerIdLabs
      type
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      residentId
      deleted
      cleaningRequests {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPaymentMethods = /* GraphQL */ `
  query ListPaymentMethods(
    $filter: ModelPaymentMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentMethods(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        nickName
        payerReferenceId
        payerSecondaryRefId
        gatewayPayerId
        payerReferenceIdLabs
        gatewayPayerIdLabs
        type
        residentId
        deleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServiceRequest = /* GraphQL */ `
  query GetServiceRequest($id: ID!) {
    getServiceRequest(id: $id) {
      id
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      yardiServiceRequestId
      serviceRequestResidentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      createdAt
      statusHistory {
        timestamp
        yardiStatus
        status
        __typename
      }
      currentStatus
      requestedBy
      category
      accessNotes
      technicianNotes
      briefDescription
      fullDescription
      attachments {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      hasPermissionToEnter
      hasAttachmentsToSync
      hasExternalOrigin
      isClosed
      updatedAt
      __typename
    }
  }
`;
export const listServiceRequests = /* GraphQL */ `
  query ListServiceRequests(
    $filter: ModelServiceRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        buildingId
        yardiServiceRequestId
        serviceRequestResidentId
        createdAt
        currentStatus
        requestedBy
        category
        accessNotes
        technicianNotes
        briefDescription
        fullDescription
        hasPermissionToEnter
        hasAttachmentsToSync
        hasExternalOrigin
        isClosed
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      timestamp
      updatedAt
      createdAt
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      paymentResidentId
      residentId
      paymentReferenceId
      paymentTraceId
      payeeId
      incurFee
      feeAmount
      totalAmount
      unitAmount
      transactionId
      paymentMethodId
      paymentMethod {
        id
        nickName
        payerReferenceId
        payerSecondaryRefId
        gatewayPayerId
        payerReferenceIdLabs
        gatewayPayerIdLabs
        type
        residentId
        deleted
        createdAt
        updatedAt
        __typename
      }
      paymentAutoPayId
      autoPay {
        id
        residentId
        autoPayPaymentMethodId
        lastNotifiedAt
        endDate
        active
        percentage
        createdAt
        updatedAt
        __typename
      }
      balanceDetails
      invoiceId
      status
      failureReason
      __typename
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        timestamp
        updatedAt
        createdAt
        paymentResidentId
        residentId
        paymentReferenceId
        paymentTraceId
        payeeId
        incurFee
        feeAmount
        totalAmount
        unitAmount
        transactionId
        paymentMethodId
        paymentAutoPayId
        balanceDetails
        invoiceId
        status
        failureReason
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvoice = /* GraphQL */ `
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      occupancyId
      occupancy {
        id
        createdAt
        status
        leaseFromDate
        occupancyUnitId
        yardiId
        disabledFeatures
        mustUpdateLedger
        isRentSuspended
        leaseToDate
        onboardingMeta
        ledgerLastUpdatedAt
        isUnitTransfer
        isAffordable
        updatedAt
        __typename
      }
      subTotal
      tax
      fee
      total
      amountPaid
      status
      statusHistory {
        timestamp
        status
        __typename
      }
      payments {
        nextToken
        __typename
      }
      issuedAt
      dueAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInvoices = /* GraphQL */ `
  query ListInvoices(
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        buildingId
        occupancyId
        subTotal
        tax
        fee
        total
        amountPaid
        status
        issuedAt
        dueAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResident = /* GraphQL */ `
  query GetResident($id: ID!) {
    getResident(id: $id) {
      id
      createdAt
      updatedAt
      phoneNumber
      email
      displayName
      occupancy {
        id
        createdAt
        status
        leaseFromDate
        occupancyUnitId
        yardiId
        disabledFeatures
        mustUpdateLedger
        isRentSuspended
        leaseToDate
        onboardingMeta
        ledgerLastUpdatedAt
        isUnitTransfer
        isAffordable
        updatedAt
        __typename
      }
      residentOccupancyId
      conversation {
        id
        conversationResidentId
        conversationBuildingId
        lastMessageAt
        staffLastReadAt
        residentReadAt
        status
        createdAt
        updatedAt
        __typename
      }
      referenceId
      secondaryReferenceId
      propertyCodeOverride
      prospectCode
      userProfile
      profileImage {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      pushAddress
      payments {
        nextToken
        __typename
      }
      paymentMethods {
        nextToken
        __typename
      }
      serviceRequests {
        id
        buildingId
        yardiServiceRequestId
        serviceRequestResidentId
        createdAt
        currentStatus
        requestedBy
        category
        accessNotes
        technicianNotes
        briefDescription
        fullDescription
        hasPermissionToEnter
        hasAttachmentsToSync
        hasExternalOrigin
        isClosed
        updatedAt
        __typename
      }
      notificationSettings {
        nextToken
        __typename
      }
      autoPay {
        nextToken
        __typename
      }
      moveInDate
      moveOutDate
      statusOverride
      standing
      standingMeta
      isTest
      residentGroup
      dateClaimed
      guests {
        nextToken
        __typename
      }
      nudgeCheckedAt
      isDeleted
      vendorServiceCredits {
        nextToken
        __typename
      }
      announcements {
        nextToken
        __typename
      }
      onboardingMeta
      lastLoggedInAt
      smartRentMeta
      __typename
    }
  }
`;
export const listResidents = /* GraphQL */ `
  query ListResidents(
    $filter: ModelResidentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResidents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPetProfile = /* GraphQL */ `
  query GetPetProfile($id: ID!) {
    getPetProfile(id: $id) {
      id
      createdAt
      updatedAt
      occupancyId
      displayName
      species
      breed
      weight
      birthday
      isDeleted
      vendorAppointments {
        nextToken
        __typename
      }
      notes
      image {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      __typename
    }
  }
`;
export const listPetProfiles = /* GraphQL */ `
  query ListPetProfiles(
    $filter: ModelPetProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPetProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        occupancyId
        displayName
        species
        breed
        weight
        birthday
        isDeleted
        notes
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPetProfileVendorAppointment = /* GraphQL */ `
  query GetPetProfileVendorAppointment($id: ID!) {
    getPetProfileVendorAppointment(id: $id) {
      id
      petProfileId
      petProfile {
        id
        createdAt
        updatedAt
        occupancyId
        displayName
        species
        breed
        weight
        birthday
        isDeleted
        notes
        __typename
      }
      vendorAppointmentId
      vendorAppointment {
        id
        vendorServiceId
        foreignAppointmentId
        buildingId
        unitId
        residentId
        status
        reminderSentAt
        startAt
        endAt
        notes
        cost
        paymentMethodId
        paymentId
        amenityReservationId
        recurringVendorAppointmentId
        yardiBatchId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPetProfileVendorAppointments = /* GraphQL */ `
  query ListPetProfileVendorAppointments(
    $filter: ModelPetProfileVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPetProfileVendorAppointments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        petProfileId
        vendorAppointmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStaff = /* GraphQL */ `
  query GetStaff($id: ID!) {
    getStaff(id: $id) {
      id
      phoneNumber
      userName
      passwordResetMeta
      displayName
      permissionGroup
      buildings {
        nextToken
        __typename
      }
      messages {
        nextToken
        __typename
      }
      notificationSettings {
        nextToken
        __typename
      }
      profileImage {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      dateClaimed
      lastLoggedInAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStaffs = /* GraphQL */ `
  query ListStaffs(
    $filter: ModelStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStaffNote = /* GraphQL */ `
  query GetStaffNote($id: ID!) {
    getStaffNote(id: $id) {
      id
      buildingId
      staffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      isDeleted
      isPinned
      isSticky
      staffNoteId
      __typename
    }
  }
`;
export const listStaffNotes = /* GraphQL */ `
  query ListStaffNotes(
    $filter: ModelStaffNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        buildingId
        staffId
        content
        createdAt
        updatedAt
        isDeleted
        isPinned
        isSticky
        staffNoteId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      id
      conversationResidentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      conversationBuildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      lastMessageAt
      lastMessage {
        id
        createdAt
        messageConversationId
        messageStaffId
        recipient
        body
        type
        topic
        updatedAt
        __typename
      }
      staffLastReadAt
      residentReadAt
      status
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listConversations = /* GraphQL */ `
  query ListConversations(
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversationResidentId
        conversationBuildingId
        lastMessageAt
        staffLastReadAt
        residentReadAt
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAutoPay = /* GraphQL */ `
  query GetAutoPay($id: ID!) {
    getAutoPay(id: $id) {
      id
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      residentId
      autoPayPaymentMethodId
      paymentMethod {
        id
        nickName
        payerReferenceId
        payerSecondaryRefId
        gatewayPayerId
        payerReferenceIdLabs
        gatewayPayerIdLabs
        type
        residentId
        deleted
        createdAt
        updatedAt
        __typename
      }
      lastNotifiedAt
      endDate
      active
      percentage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAutoPays = /* GraphQL */ `
  query ListAutoPays(
    $filter: ModelAutoPayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAutoPays(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        residentId
        autoPayPaymentMethodId
        lastNotifiedAt
        endDate
        active
        percentage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      id
      createdAt
      messageConversationId
      conversation {
        id
        conversationResidentId
        conversationBuildingId
        lastMessageAt
        staffLastReadAt
        residentReadAt
        status
        createdAt
        updatedAt
        __typename
      }
      messageStaffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      recipient
      body
      image {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      type
      topic
      updatedAt
      __typename
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        messageConversationId
        messageStaffId
        recipient
        body
        type
        topic
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getScheduledMessage = /* GraphQL */ `
  query GetScheduledMessage($id: ID!) {
    getScheduledMessage(id: $id) {
      id
      scheduledSendAt
      conversationId
      conversation {
        id
        conversationResidentId
        conversationBuildingId
        lastMessageAt
        staffLastReadAt
        residentReadAt
        status
        createdAt
        updatedAt
        __typename
      }
      staffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      recipient
      body
      image {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      type
      topic
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      buildingTimezone
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listScheduledMessages = /* GraphQL */ `
  query ListScheduledMessages(
    $filter: ModelScheduledMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listScheduledMessages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledSendAt
        conversationId
        staffId
        recipient
        body
        type
        topic
        buildingId
        buildingTimezone
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      staffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      rating
      feedback
      type
      foreignId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks(
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        residentId
        staffId
        buildingId
        rating
        feedback
        type
        foreignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      createdAt
      readAt
      residentId
      type
      status
      dueAt
      updatedAt
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        readAt
        residentId
        type
        status
        dueAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCleaningRequest = /* GraphQL */ `
  query GetCleaningRequest($id: ID!) {
    getCleaningRequest(id: $id) {
      id
      cleaningRequestBuildingId
      serviceRequestId
      occupancy {
        id
        createdAt
        status
        leaseFromDate
        occupancyUnitId
        yardiId
        disabledFeatures
        mustUpdateLedger
        isRentSuspended
        leaseToDate
        onboardingMeta
        ledgerLastUpdatedAt
        isUnitTransfer
        isAffordable
        updatedAt
        __typename
      }
      residentId
      cleaningPackage
      submittedAt
      requestedTime
      slot
      status
      note
      images {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      visits {
        nextToken
        __typename
      }
      scheduleInfoJSON
      recurring
      recurringFrequency
      recurringEndDate
      residentQuote
      cleaningRequestPaymentMethodId
      paymentMethod {
        id
        nickName
        payerReferenceId
        payerSecondaryRefId
        gatewayPayerId
        payerReferenceIdLabs
        gatewayPayerIdLabs
        type
        residentId
        deleted
        createdAt
        updatedAt
        __typename
      }
      finalPaymentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCleaningRequests = /* GraphQL */ `
  query ListCleaningRequests(
    $filter: ModelCleaningRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCleaningRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cleaningRequestBuildingId
        serviceRequestId
        residentId
        cleaningPackage
        submittedAt
        requestedTime
        slot
        status
        note
        scheduleInfoJSON
        recurring
        recurringFrequency
        recurringEndDate
        residentQuote
        cleaningRequestPaymentMethodId
        finalPaymentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEdenVisit = /* GraphQL */ `
  query GetEdenVisit($id: ID!) {
    getEdenVisit(id: $id) {
      id
      visitBuildingId
      request {
        id
        cleaningRequestBuildingId
        serviceRequestId
        residentId
        cleaningPackage
        submittedAt
        requestedTime
        slot
        status
        note
        scheduleInfoJSON
        recurring
        recurringFrequency
        recurringEndDate
        residentQuote
        cleaningRequestPaymentMethodId
        finalPaymentId
        createdAt
        updatedAt
        __typename
      }
      appointmentStart
      appointmentEnd
      visitInfoJSON
      residentPrice
      edenVisitPaymentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEdenVisits = /* GraphQL */ `
  query ListEdenVisits(
    $filter: ModelEdenVisitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEdenVisits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        visitBuildingId
        appointmentStart
        appointmentEnd
        visitInfoJSON
        residentPrice
        edenVisitPaymentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResidentEvent = /* GraphQL */ `
  query GetResidentEvent($id: ID!) {
    getResidentEvent(id: $id) {
      id
      residentId
      label
      primaryRecord
      primaryRecordId
      shortLabel
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listResidentEvents = /* GraphQL */ `
  query ListResidentEvents(
    $filter: ModelResidentEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResidentEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        residentId
        label
        primaryRecord
        primaryRecordId
        shortLabel
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAmenity = /* GraphQL */ `
  query GetAmenity($id: ID!) {
    getAmenity(id: $id) {
      id
      resourceId
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      amenityReservation {
        nextToken
        __typename
      }
      label
      description
      rules
      mustAgreeToRules
      ignoreBookInAdvanceForStaff
      needsApproval
      weeklyReservationLimit
      attachments {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      isVisible
      isOnboardingOnly
      requiresPayment
      depositPrice
      hourlyPrice
      childAmenities {
        nextToken
        __typename
      }
      parentAmenities {
        nextToken
        __typename
      }
      amenityType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAmenitys = /* GraphQL */ `
  query ListAmenitys(
    $filter: ModelAmenityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenitys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        resourceId
        buildingId
        label
        description
        rules
        mustAgreeToRules
        ignoreBookInAdvanceForStaff
        needsApproval
        weeklyReservationLimit
        isVisible
        isOnboardingOnly
        requiresPayment
        depositPrice
        hourlyPrice
        amenityType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAmenityLink = /* GraphQL */ `
  query GetAmenityLink($id: ID!) {
    getAmenityLink(id: $id) {
      id
      parentAmenityId
      parentAmenity {
        id
        resourceId
        buildingId
        label
        description
        rules
        mustAgreeToRules
        ignoreBookInAdvanceForStaff
        needsApproval
        weeklyReservationLimit
        isVisible
        isOnboardingOnly
        requiresPayment
        depositPrice
        hourlyPrice
        amenityType
        createdAt
        updatedAt
        __typename
      }
      childAmenityId
      childAmenity {
        id
        resourceId
        buildingId
        label
        description
        rules
        mustAgreeToRules
        ignoreBookInAdvanceForStaff
        needsApproval
        weeklyReservationLimit
        isVisible
        isOnboardingOnly
        requiresPayment
        depositPrice
        hourlyPrice
        amenityType
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAmenityLinks = /* GraphQL */ `
  query ListAmenityLinks(
    $filter: ModelAmenityLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        parentAmenityId
        childAmenityId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAmenityLinkClosure = /* GraphQL */ `
  query GetAmenityLinkClosure($id: ID!) {
    getAmenityLinkClosure(id: $id) {
      id
      closureId
      originClosureId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAmenityLinkClosures = /* GraphQL */ `
  query ListAmenityLinkClosures(
    $filter: ModelAmenityLinkClosureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityLinkClosures(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        closureId
        originClosureId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAmenityReservation = /* GraphQL */ `
  query GetAmenityReservation($id: ID!) {
    getAmenityReservation(id: $id) {
      id
      reservationId
      amenityId
      amenity {
        id
        resourceId
        buildingId
        label
        description
        rules
        mustAgreeToRules
        ignoreBookInAdvanceForStaff
        needsApproval
        weeklyReservationLimit
        isVisible
        isOnboardingOnly
        requiresPayment
        depositPrice
        hourlyPrice
        amenityType
        createdAt
        updatedAt
        __typename
      }
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      staffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      title
      useCase
      startAt
      endAt
      partySize
      reservationState
      isSystemControlled
      createdAt
      updatedAt
      notes
      isOnboardingOnly
      originId
      paymentMethodId
      depositPaymentId
      depositPayment {
        id
        timestamp
        updatedAt
        createdAt
        paymentResidentId
        residentId
        paymentReferenceId
        paymentTraceId
        payeeId
        incurFee
        feeAmount
        totalAmount
        unitAmount
        transactionId
        paymentMethodId
        paymentAutoPayId
        balanceDetails
        invoiceId
        status
        failureReason
        __typename
      }
      bookingPaymentId
      bookingPayment {
        id
        timestamp
        updatedAt
        createdAt
        paymentResidentId
        residentId
        paymentReferenceId
        paymentTraceId
        payeeId
        incurFee
        feeAmount
        totalAmount
        unitAmount
        transactionId
        paymentMethodId
        paymentAutoPayId
        balanceDetails
        invoiceId
        status
        failureReason
        __typename
      }
      depositCost
      hourlyCost
      __typename
    }
  }
`;
export const listAmenityReservations = /* GraphQL */ `
  query ListAmenityReservations(
    $filter: ModelAmenityReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityReservations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reservationId
        amenityId
        buildingId
        residentId
        staffId
        title
        useCase
        startAt
        endAt
        partySize
        reservationState
        isSystemControlled
        createdAt
        updatedAt
        notes
        isOnboardingOnly
        originId
        paymentMethodId
        depositPaymentId
        bookingPaymentId
        depositCost
        hourlyCost
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBuildingNudge = /* GraphQL */ `
  query GetBuildingNudge($id: ID!) {
    getBuildingNudge(id: $id) {
      id
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      buildingActions {
        nextToken
        __typename
      }
      type
      label
      triggeredAt
      expiredAt
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBuildingNudges = /* GraphQL */ `
  query ListBuildingNudges(
    $filter: ModelBuildingNudgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingNudges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        buildingId
        residentId
        type
        label
        triggeredAt
        expiredAt
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBuildingAction = /* GraphQL */ `
  query GetBuildingAction($id: ID!) {
    getBuildingAction(id: $id) {
      id
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      staffId
      buildingNudgeId
      cost
      reason
      notes
      attachments {
        bucket
        region
        key
        displayName
        contentType
        isSynced
        __typename
      }
      actions
      actionTakenAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBuildingActions = /* GraphQL */ `
  query ListBuildingActions(
    $filter: ModelBuildingActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingActions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        buildingId
        residentId
        staffId
        buildingNudgeId
        cost
        reason
        notes
        actions
        actionTakenAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVendorService = /* GraphQL */ `
  query GetVendorService($id: ID!) {
    getVendorService(id: $id) {
      id
      foreignServiceId
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      label
      type
      subType
      addOnOptions {
        label
        description
        price
        __typename
      }
      price
      duration
      details {
        description
        shortDescription
        vendorDescription
        cancellationPolicy
        __typename
      }
      amenityId
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVendorServices = /* GraphQL */ `
  query ListVendorServices(
    $filter: ModelVendorServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        foreignServiceId
        buildingId
        label
        type
        subType
        price
        duration
        amenityId
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVendorServiceCredit = /* GraphQL */ `
  query GetVendorServiceCredit($id: ID!) {
    getVendorServiceCredit(id: $id) {
      id
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      category
      title
      description
      amount
      discountType
      expiredAt
      vendorServiceTypes
      notes
      staffId
      staff {
        id
        phoneNumber
        userName
        passwordResetMeta
        displayName
        permissionGroup
        dateClaimed
        lastLoggedInAt
        createdAt
        updatedAt
        __typename
      }
      vendorAppointmentId
      vendorAppointment {
        id
        vendorServiceId
        foreignAppointmentId
        buildingId
        unitId
        residentId
        status
        reminderSentAt
        startAt
        endAt
        notes
        cost
        paymentMethodId
        paymentId
        amenityReservationId
        recurringVendorAppointmentId
        yardiBatchId
        createdAt
        updatedAt
        __typename
      }
      vendorServicePromotionId
      vendorServicePromotion {
        id
        buildingId
        title
        description
        amount
        discountType
        startedAt
        expiredAt
        vendorServiceTypes
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVendorServiceCredits = /* GraphQL */ `
  query ListVendorServiceCredits(
    $filter: ModelVendorServiceCreditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServiceCredits(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        category
        title
        description
        amount
        discountType
        expiredAt
        vendorServiceTypes
        notes
        staffId
        vendorAppointmentId
        vendorServicePromotionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVendorServicePromotion = /* GraphQL */ `
  query GetVendorServicePromotion($id: ID!) {
    getVendorServicePromotion(id: $id) {
      id
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      title
      description
      amount
      discountType
      startedAt
      expiredAt
      vendorServiceTypes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVendorServicePromotions = /* GraphQL */ `
  query ListVendorServicePromotions(
    $filter: ModelVendorServicePromotionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServicePromotions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        title
        description
        amount
        discountType
        startedAt
        expiredAt
        vendorServiceTypes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVendorAppointment = /* GraphQL */ `
  query GetVendorAppointment($id: ID!) {
    getVendorAppointment(id: $id) {
      id
      vendorServiceId
      vendorService {
        id
        foreignServiceId
        buildingId
        label
        type
        subType
        price
        duration
        amenityId
        order
        createdAt
        updatedAt
        __typename
      }
      foreignAppointmentId
      buildingId
      building {
        id
        displayName
        yardiId
        oscarId
        email
        streetAddress
        city
        state
        zipCode
        website
        phoneNumber
        officeHours
        deskHoursEnabled
        disabledFeatures
        socialLinks
        emergencyMaintenancePhoneNumber
        taxRate
        outOfOfficeStatus
        freeCleaningOffering
        launchDate
        supportEmail
        lastSyncedYardi
        lastSyncedOscar
        leaseRenewalURL
        supportFormURL
        timezone
        outOfOfficeMessage
        onboardingSchema
        smartHubLaunchDate
        leaveAReviewURL
        organizationId
        dummyResidentId
        createdAt
        updatedAt
        __typename
      }
      unitId
      residentId
      resident {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      status
      reminderSentAt
      startAt
      endAt
      notes
      cost
      addOns {
        label
        cost
        __typename
      }
      paymentMethodId
      paymentMethod {
        id
        nickName
        payerReferenceId
        payerSecondaryRefId
        gatewayPayerId
        payerReferenceIdLabs
        gatewayPayerIdLabs
        type
        residentId
        deleted
        createdAt
        updatedAt
        __typename
      }
      paymentId
      payment {
        id
        timestamp
        updatedAt
        createdAt
        paymentResidentId
        residentId
        paymentReferenceId
        paymentTraceId
        payeeId
        incurFee
        feeAmount
        totalAmount
        unitAmount
        transactionId
        paymentMethodId
        paymentAutoPayId
        balanceDetails
        invoiceId
        status
        failureReason
        __typename
      }
      amenityReservationId
      amenityReservation {
        id
        reservationId
        amenityId
        buildingId
        residentId
        staffId
        title
        useCase
        startAt
        endAt
        partySize
        reservationState
        isSystemControlled
        createdAt
        updatedAt
        notes
        isOnboardingOnly
        originId
        paymentMethodId
        depositPaymentId
        bookingPaymentId
        depositCost
        hourlyCost
        __typename
      }
      recurringVendorAppointmentId
      recurringVendorAppointment {
        id
        vendorServiceId
        buildingId
        unitId
        residentId
        paymentMethodId
        frequency
        notes
        metaPetProfileIds
        firstOccurredAt
        lastOccurredAt
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      petProfiles {
        nextToken
        __typename
      }
      yardiBatchId
      createdAt
      updatedAt
      vendorServiceCredits {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listVendorAppointments = /* GraphQL */ `
  query ListVendorAppointments(
    $filter: ModelVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorAppointments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        foreignAppointmentId
        buildingId
        unitId
        residentId
        status
        reminderSentAt
        startAt
        endAt
        notes
        cost
        paymentMethodId
        paymentId
        amenityReservationId
        recurringVendorAppointmentId
        yardiBatchId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecurringVendorAppointment = /* GraphQL */ `
  query GetRecurringVendorAppointment($id: ID!) {
    getRecurringVendorAppointment(id: $id) {
      id
      vendorServiceId
      vendorService {
        id
        foreignServiceId
        buildingId
        label
        type
        subType
        price
        duration
        amenityId
        order
        createdAt
        updatedAt
        __typename
      }
      buildingId
      unitId
      residentId
      paymentMethodId
      paymentMethod {
        id
        nickName
        payerReferenceId
        payerSecondaryRefId
        gatewayPayerId
        payerReferenceIdLabs
        gatewayPayerIdLabs
        type
        residentId
        deleted
        createdAt
        updatedAt
        __typename
      }
      frequency
      notes
      addOns {
        label
        cost
        __typename
      }
      metaPetProfileIds
      firstOccurredAt
      lastOccurredAt
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecurringVendorAppointments = /* GraphQL */ `
  query ListRecurringVendorAppointments(
    $filter: ModelRecurringVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecurringVendorAppointments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        buildingId
        unitId
        residentId
        paymentMethodId
        frequency
        notes
        metaPetProfileIds
        firstOccurredAt
        lastOccurredAt
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSisterBuildingsByPrimaryBuilding = /* GraphQL */ `
  query ListSisterBuildingsByPrimaryBuilding(
    $primaryBuildingId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSisterBuildingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSisterBuildingsByPrimaryBuilding(
      primaryBuildingId: $primaryBuildingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryBuildingId
        sisterBuildingId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSisterBuildingsBySisterBuilding = /* GraphQL */ `
  query ListSisterBuildingsBySisterBuilding(
    $sisterBuildingId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSisterBuildingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSisterBuildingsBySisterBuilding(
      sisterBuildingId: $sisterBuildingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        primaryBuildingId
        sisterBuildingId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDocumentsByOrganization = /* GraphQL */ `
  query ListDocumentsByOrganization(
    $organizationId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocumentsByOrganization(
      organizationId: $organizationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        internalName
        displayName
        category
        documentTags
        residentGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingDocumentsByBuilding = /* GraphQL */ `
  query ListBuildingDocumentsByBuilding(
    $buildingId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingDocumentsByBuilding(
      buildingId: $buildingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        documentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingDocumentsByDocument = /* GraphQL */ `
  query ListBuildingDocumentsByDocument(
    $documentId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingDocumentsByDocument(
      documentId: $documentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        documentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const announcementsByBuildingAndActiveEnd = /* GraphQL */ `
  query AnnouncementsByBuildingAndActiveEnd(
    $announcementsBuildingId: ID
    $activeEnd: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    announcementsByBuildingAndActiveEnd(
      announcementsBuildingId: $announcementsBuildingId
      activeEnd: $activeEnd
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        activeStart
        activeEnd
        headline
        text
        htmlText
        announcementsBuildingId
        staffId
        audienceLabel
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResidentAnnouncementsByAnnouncement = /* GraphQL */ `
  query ListResidentAnnouncementsByAnnouncement(
    $announcementId: ID
    $residentId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResidentAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResidentAnnouncementsByAnnouncement(
      announcementId: $announcementId
      residentId: $residentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        announcementId
        residentId
        readAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResidentAnnouncementsByResident = /* GraphQL */ `
  query ListResidentAnnouncementsByResident(
    $residentId: ID
    $announcementId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResidentAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResidentAnnouncementsByResident(
      residentId: $residentId
      announcementId: $announcementId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        announcementId
        residentId
        readAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAppEngagementsByEntityType = /* GraphQL */ `
  query ListAppEngagementsByEntityType(
    $entityType: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAppEngagementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppEngagementsByEntityType(
      entityType: $entityType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        entityType
        entityId
        action
        createdAt
        meta
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAppEngagementsByEntity = /* GraphQL */ `
  query ListAppEngagementsByEntity(
    $entityId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAppEngagementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppEngagementsByEntity(
      entityId: $entityId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        entityType
        entityId
        action
        createdAt
        meta
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAppEngagementsByResident = /* GraphQL */ `
  query ListAppEngagementsByResident(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAppEngagementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppEngagementsByResident(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        entityType
        entityId
        action
        createdAt
        meta
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listChatRoomsByBuilding = /* GraphQL */ `
  query ListChatRoomsByBuilding(
    $buildingId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChatRoomFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatRoomsByBuilding(
      buildingId: $buildingId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        displayName
        buildingId
        status
        lastChatMessageId
        participantIds
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listChatParticipantsByParticipant = /* GraphQL */ `
  query ListChatParticipantsByParticipant(
    $participantId: ID
    $lastSeenAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChatParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatParticipantsByParticipant(
      participantId: $participantId
      lastSeenAt: $lastSeenAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chatRoomId
        participantId
        displayName
        isStaffParticipant
        lastSeenAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listChatParticipantsByChatRoom = /* GraphQL */ `
  query ListChatParticipantsByChatRoom(
    $chatRoomId: ID
    $lastSeenAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChatParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatParticipantsByChatRoom(
      chatRoomId: $chatRoomId
      lastSeenAt: $lastSeenAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chatRoomId
        participantId
        displayName
        isStaffParticipant
        lastSeenAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOnboardingTasksByOccupancy = /* GraphQL */ `
  query ListOnboardingTasksByOccupancy(
    $occupancyId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOnboardingTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOnboardingTasksByOccupancy(
      occupancyId: $occupancyId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        occupancyId
        dependsOn
        state
        requiresApproval
        importance
        supportsMultipleSubmissions
        label
        key
        form
        taskMeta
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGuestsByResident = /* GraphQL */ `
  query ListGuestsByResident(
    $residentId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelGuestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuestsByResident(
      residentId: $residentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        registrationExpiry
        meetingOption
        instructions
        residentId
        buildingId
        unitId
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGuestsByBuilding = /* GraphQL */ `
  query ListGuestsByBuilding(
    $buildingId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelGuestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuestsByBuilding(
      buildingId: $buildingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        registrationExpiry
        meetingOption
        instructions
        residentId
        buildingId
        unitId
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGuestsByUnit = /* GraphQL */ `
  query ListGuestsByUnit(
    $unitId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelGuestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuestsByUnit(
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        registrationExpiry
        meetingOption
        instructions
        residentId
        buildingId
        unitId
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGuestVisitsByGuest = /* GraphQL */ `
  query ListGuestVisitsByGuest(
    $guestId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGuestVisitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuestVisitsByGuest(
      guestId: $guestId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        isPermanent
        guestName
        residentName
        unitNumber
        buildingId
        guestId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGuestVisitsByBuilding = /* GraphQL */ `
  query ListGuestVisitsByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGuestVisitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuestVisitsByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        isPermanent
        guestName
        residentName
        unitNumber
        buildingId
        guestId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listNotificationSettingsByResident = /* GraphQL */ `
  query ListNotificationSettingsByResident(
    $residentId: ID
    $categoryMedium: ModelNotificationSettingByResidentCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationSettingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationSettingsByResident(
      residentId: $residentId
      categoryMedium: $categoryMedium
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        category
        medium
        residentId
        isUnsubscribed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listEnqueuedNotificationsByEntityKey = /* GraphQL */ `
  query ListEnqueuedNotificationsByEntityKey(
    $entityKey: ID
    $sendAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEnqueuedNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEnqueuedNotificationsByEntityKey(
      entityKey: $entityKey
      sendAt: $sendAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityKey
        medium
        payload
        addresses
        sendAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDeliverysByResident = /* GraphQL */ `
  query ListDeliverysByResident(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliverysByResident(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        trackingNumber
        carrier
        packageType
        priority
        notes
        createdAt
        receivedAt
        residentId
        unitId
        buildingId
        isDeleted
        staffId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDeliverysByBuilding = /* GraphQL */ `
  query ListDeliverysByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliverysByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        trackingNumber
        carrier
        packageType
        priority
        notes
        createdAt
        receivedAt
        residentId
        unitId
        buildingId
        isDeleted
        staffId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOutgoingDeliverysByResident = /* GraphQL */ `
  query ListOutgoingDeliverysByResident(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutgoingDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutgoingDeliverysByResident(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        carrier
        packageType
        createdAt
        shippedAt
        residentId
        unitId
        buildingId
        trackingNumber
        notes
        isDeleted
        staffId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOutgoingDeliverysByBuilding = /* GraphQL */ `
  query ListOutgoingDeliverysByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutgoingDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutgoingDeliverysByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        carrier
        packageType
        createdAt
        shippedAt
        residentId
        unitId
        buildingId
        trackingNumber
        notes
        isDeleted
        staffId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliveriesByIntegration = /* GraphQL */ `
  query DeliveriesByIntegration(
    $integrationId: String
    $integrationName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIntegratedDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveriesByIntegration(
      integrationId: $integrationId
      integrationName: $integrationName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        integrationName
        integrationId
        deliveryId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingPartnersByBuilding = /* GraphQL */ `
  query ListBuildingPartnersByBuilding(
    $buildingId: ID
    $partnerId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingPartnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingPartnersByBuilding(
      buildingId: $buildingId
      partnerId: $partnerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        partnerId
        buildingId
        isFeatured
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingPartnersByPartner = /* GraphQL */ `
  query ListBuildingPartnersByPartner(
    $partnerId: ID
    $buildingId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingPartnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingPartnersByPartner(
      partnerId: $partnerId
      buildingId: $buildingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        partnerId
        buildingId
        isFeatured
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingStaffByBuilding = /* GraphQL */ `
  query ListBuildingStaffByBuilding(
    $buildingId: ID
    $staffId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingStaffByBuilding(
      buildingId: $buildingId
      staffId: $staffId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        staffId
        isDisabled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingStaffByStaff = /* GraphQL */ `
  query ListBuildingStaffByStaff(
    $staffId: ID
    $buildingId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingStaffByStaff(
      staffId: $staffId
      buildingId: $buildingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        staffId
        isDisabled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSocialEventsByBuilding = /* GraphQL */ `
  query ListSocialEventsByBuilding(
    $socialEventBuildingId: ID
    $startTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSocialEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSocialEventsByBuilding(
      socialEventBuildingId: $socialEventBuildingId
      startTime: $startTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventName
        socialEventBuildingId
        startTime
        endTime
        previewDescription
        description
        htmlDescription
        payRequired
        pricePerPerson
        rsvpRequired
        capacity
        location
        headcount
        allowResidentsToViewRsvps
        allowResidentGuestRsvps
        allowWaitlist
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSocialEventResponsesBySocialEvent = /* GraphQL */ `
  query ListSocialEventResponsesBySocialEvent(
    $socialEventId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSocialEventResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSocialEventResponsesBySocialEvent(
      socialEventId: $socialEventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        socialEventId
        residentId
        partySize
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitsByBuildingAndNumber = /* GraphQL */ `
  query UnitsByBuildingAndNumber(
    $unitBuildingId: ID
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitsByBuildingAndNumber(
      unitBuildingId: $unitBuildingId
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        number
        unitBuildingId
        sqft
        bedrooms
        bathrooms
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUnitTagsByBuilding = /* GraphQL */ `
  query ListUnitTagsByBuilding(
    $buildingId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUnitTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnitTagsByBuilding(
      buildingId: $buildingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        label
        metaNumbers
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUnitTagUnitsByUnit = /* GraphQL */ `
  query ListUnitTagUnitsByUnit(
    $unitId: ID
    $unitTagId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUnitTagUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnitTagUnitsByUnit(
      unitId: $unitId
      unitTagId: $unitTagId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        unitTagId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUnitTagUnitsByUnitTag = /* GraphQL */ `
  query ListUnitTagUnitsByUnitTag(
    $unitTagId: ID
    $unitId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUnitTagUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnitTagUnitsByUnitTag(
      unitTagId: $unitTagId
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        unitId
        unitTagId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOccupancysByYardiId = /* GraphQL */ `
  query ListOccupancysByYardiId(
    $yardiId: String
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOccupancyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOccupancysByYardiId(
      yardiId: $yardiId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        status
        leaseFromDate
        occupancyUnitId
        yardiId
        disabledFeatures
        mustUpdateLedger
        isRentSuspended
        leaseToDate
        onboardingMeta
        ledgerLastUpdatedAt
        isUnitTransfer
        isAffordable
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPaymentMethodsByResident = /* GraphQL */ `
  query ListPaymentMethodsByResident(
    $residentId: String
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentMethodFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentMethodsByResident(
      residentId: $residentId
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        nickName
        payerReferenceId
        payerSecondaryRefId
        gatewayPayerId
        payerReferenceIdLabs
        gatewayPayerIdLabs
        type
        residentId
        deleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceRequestByCreatedAt = /* GraphQL */ `
  query ServiceRequestByCreatedAt(
    $serviceRequestResidentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelServiceRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceRequestByCreatedAt(
      serviceRequestResidentId: $serviceRequestResidentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        yardiServiceRequestId
        serviceRequestResidentId
        createdAt
        currentStatus
        requestedBy
        category
        accessNotes
        technicianNotes
        briefDescription
        fullDescription
        hasPermissionToEnter
        hasAttachmentsToSync
        hasExternalOrigin
        isClosed
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listServiceRequestsByBuilding = /* GraphQL */ `
  query ListServiceRequestsByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelServiceRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceRequestsByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        yardiServiceRequestId
        serviceRequestResidentId
        createdAt
        currentStatus
        requestedBy
        category
        accessNotes
        technicianNotes
        briefDescription
        fullDescription
        hasPermissionToEnter
        hasAttachmentsToSync
        hasExternalOrigin
        isClosed
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listServiceRequestsByIsClosed = /* GraphQL */ `
  query ListServiceRequestsByIsClosed(
    $isClosed: PSEUDO_BOOLEAN
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelServiceRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceRequestsByIsClosed(
      isClosed: $isClosed
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        yardiServiceRequestId
        serviceRequestResidentId
        createdAt
        currentStatus
        requestedBy
        category
        accessNotes
        technicianNotes
        briefDescription
        fullDescription
        hasPermissionToEnter
        hasAttachmentsToSync
        hasExternalOrigin
        isClosed
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listServiceRequestsByYardiServiceRequestId = /* GraphQL */ `
  query ListServiceRequestsByYardiServiceRequestId(
    $yardiServiceRequestId: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelServiceRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceRequestsByYardiServiceRequestId(
      yardiServiceRequestId: $yardiServiceRequestId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        yardiServiceRequestId
        serviceRequestResidentId
        createdAt
        currentStatus
        requestedBy
        category
        accessNotes
        technicianNotes
        briefDescription
        fullDescription
        hasPermissionToEnter
        hasAttachmentsToSync
        hasExternalOrigin
        isClosed
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPaymentsByTransactionId = /* GraphQL */ `
  query ListPaymentsByTransactionId(
    $transactionId: String
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByTransactionId(
      transactionId: $transactionId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timestamp
        updatedAt
        createdAt
        paymentResidentId
        residentId
        paymentReferenceId
        paymentTraceId
        payeeId
        incurFee
        feeAmount
        totalAmount
        unitAmount
        transactionId
        paymentMethodId
        paymentAutoPayId
        balanceDetails
        invoiceId
        status
        failureReason
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPaymentsByResident = /* GraphQL */ `
  query ListPaymentsByResident(
    $residentId: String
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByResident(
      residentId: $residentId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timestamp
        updatedAt
        createdAt
        paymentResidentId
        residentId
        paymentReferenceId
        paymentTraceId
        payeeId
        incurFee
        feeAmount
        totalAmount
        unitAmount
        transactionId
        paymentMethodId
        paymentAutoPayId
        balanceDetails
        invoiceId
        status
        failureReason
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPaymentsByInvoice = /* GraphQL */ `
  query ListPaymentsByInvoice(
    $invoiceId: ID
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByInvoice(
      invoiceId: $invoiceId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timestamp
        updatedAt
        createdAt
        paymentResidentId
        residentId
        paymentReferenceId
        paymentTraceId
        payeeId
        incurFee
        feeAmount
        totalAmount
        unitAmount
        transactionId
        paymentMethodId
        paymentAutoPayId
        balanceDetails
        invoiceId
        status
        failureReason
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPaymentsByStatus = /* GraphQL */ `
  query ListPaymentsByStatus(
    $status: PaymentStatus
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByStatus(
      status: $status
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timestamp
        updatedAt
        createdAt
        paymentResidentId
        residentId
        paymentReferenceId
        paymentTraceId
        payeeId
        incurFee
        feeAmount
        totalAmount
        unitAmount
        transactionId
        paymentMethodId
        paymentAutoPayId
        balanceDetails
        invoiceId
        status
        failureReason
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listInvoicesByOccupancy = /* GraphQL */ `
  query ListInvoicesByOccupancy(
    $occupancyId: ID
    $dueAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoicesByOccupancy(
      occupancyId: $occupancyId
      dueAt: $dueAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        occupancyId
        subTotal
        tax
        fee
        total
        amountPaid
        status
        issuedAt
        dueAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listInvoicesByBuilding = /* GraphQL */ `
  query ListInvoicesByBuilding(
    $buildingId: ID
    $dueAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoicesByBuilding(
      buildingId: $buildingId
      dueAt: $dueAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        occupancyId
        subTotal
        tax
        fee
        total
        amountPaid
        status
        issuedAt
        dueAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResidentsByReferenceId = /* GraphQL */ `
  query ListResidentsByReferenceId(
    $secondaryReferenceId: String
    $referenceId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResidentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResidentsByReferenceId(
      secondaryReferenceId: $secondaryReferenceId
      referenceId: $referenceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        phoneNumber
        email
        displayName
        residentOccupancyId
        referenceId
        secondaryReferenceId
        propertyCodeOverride
        prospectCode
        userProfile
        pushAddress
        moveInDate
        moveOutDate
        statusOverride
        standing
        standingMeta
        isTest
        residentGroup
        dateClaimed
        nudgeCheckedAt
        isDeleted
        onboardingMeta
        lastLoggedInAt
        smartRentMeta
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPetProfilesByOccupancy = /* GraphQL */ `
  query ListPetProfilesByOccupancy(
    $occupancyId: ID
    $displayName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPetProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPetProfilesByOccupancy(
      occupancyId: $occupancyId
      displayName: $displayName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        occupancyId
        displayName
        species
        breed
        weight
        birthday
        isDeleted
        notes
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStaffNotesByBuilding = /* GraphQL */ `
  query ListStaffNotesByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStaffNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffNotesByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        staffId
        content
        createdAt
        updatedAt
        isDeleted
        isPinned
        isSticky
        staffNoteId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStaffNotesByBuildingSticky = /* GraphQL */ `
  query ListStaffNotesByBuildingSticky(
    $buildingId: ID
    $isStickyCreatedAt: ModelStaffNoteByBuildingStickyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStaffNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffNotesByBuildingSticky(
      buildingId: $buildingId
      isStickyCreatedAt: $isStickyCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        staffId
        content
        createdAt
        updatedAt
        isDeleted
        isPinned
        isSticky
        staffNoteId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listConversationsByBuilding = /* GraphQL */ `
  query ListConversationsByBuilding(
    $conversationBuildingId: ID
    $lastMessageAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversationsByBuilding(
      conversationBuildingId: $conversationBuildingId
      lastMessageAt: $lastMessageAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationResidentId
        conversationBuildingId
        lastMessageAt
        staffLastReadAt
        residentReadAt
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMessagesByConversation = /* GraphQL */ `
  query ListMessagesByConversation(
    $messageConversationId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessagesByConversation(
      messageConversationId: $messageConversationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        messageConversationId
        messageStaffId
        recipient
        body
        type
        topic
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listScheduledMessagesByConversation = /* GraphQL */ `
  query ListScheduledMessagesByConversation(
    $conversationId: ID
    $scheduledSendAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listScheduledMessagesByConversation(
      conversationId: $conversationId
      scheduledSendAt: $scheduledSendAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledSendAt
        conversationId
        staffId
        recipient
        body
        type
        topic
        buildingId
        buildingTimezone
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listScheduledMessagesByStaff = /* GraphQL */ `
  query ListScheduledMessagesByStaff(
    $staffId: ID
    $scheduledSendAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listScheduledMessagesByStaff(
      staffId: $staffId
      scheduledSendAt: $scheduledSendAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledSendAt
        conversationId
        staffId
        recipient
        body
        type
        topic
        buildingId
        buildingTimezone
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFeedbackByResident = /* GraphQL */ `
  query ListFeedbackByResident(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbackByResident(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        staffId
        buildingId
        rating
        feedback
        type
        foreignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFeedbackByBuilding = /* GraphQL */ `
  query ListFeedbackByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbackByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        staffId
        buildingId
        rating
        feedback
        type
        foreignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFeedbackByStaff = /* GraphQL */ `
  query ListFeedbackByStaff(
    $staffId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbackByStaff(
      staffId: $staffId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        staffId
        buildingId
        rating
        feedback
        type
        foreignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationByCreatedAt = /* GraphQL */ `
  query NotificationByCreatedAt(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationByCreatedAt(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        readAt
        residentId
        type
        status
        dueAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const buildingCleaningRequestsByStatus = /* GraphQL */ `
  query BuildingCleaningRequestsByStatus(
    $cleaningRequestBuildingId: ID
    $statusRequestedTime: ModelCleaningRequestByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCleaningRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    buildingCleaningRequestsByStatus(
      cleaningRequestBuildingId: $cleaningRequestBuildingId
      statusRequestedTime: $statusRequestedTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cleaningRequestBuildingId
        serviceRequestId
        residentId
        cleaningPackage
        submittedAt
        requestedTime
        slot
        status
        note
        scheduleInfoJSON
        recurring
        recurringFrequency
        recurringEndDate
        residentQuote
        cleaningRequestPaymentMethodId
        finalPaymentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cleaningRequestsByServiceRequest = /* GraphQL */ `
  query CleaningRequestsByServiceRequest(
    $serviceRequestId: String
    $sortDirection: ModelSortDirection
    $filter: ModelCleaningRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cleaningRequestsByServiceRequest(
      serviceRequestId: $serviceRequestId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cleaningRequestBuildingId
        serviceRequestId
        residentId
        cleaningPackage
        submittedAt
        requestedTime
        slot
        status
        note
        scheduleInfoJSON
        recurring
        recurringFrequency
        recurringEndDate
        residentQuote
        cleaningRequestPaymentMethodId
        finalPaymentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const buildingVisitsByStart = /* GraphQL */ `
  query BuildingVisitsByStart(
    $visitBuildingId: ID
    $appointmentStart: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEdenVisitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    buildingVisitsByStart(
      visitBuildingId: $visitBuildingId
      appointmentStart: $appointmentStart
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        visitBuildingId
        appointmentStart
        appointmentEnd
        visitInfoJSON
        residentPrice
        edenVisitPaymentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResidentEventsByResident = /* GraphQL */ `
  query ListResidentEventsByResident(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResidentEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResidentEventsByResident(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        label
        primaryRecord
        primaryRecordId
        shortLabel
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listResidentEventsByPrimaryRecordId = /* GraphQL */ `
  query ListResidentEventsByPrimaryRecordId(
    $primaryRecordId: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResidentEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResidentEventsByPrimaryRecordId(
      primaryRecordId: $primaryRecordId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        label
        primaryRecord
        primaryRecordId
        shortLabel
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenitysByResource = /* GraphQL */ `
  query ListAmenitysByResource(
    $resourceId: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenitysByResource(
      resourceId: $resourceId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resourceId
        buildingId
        label
        description
        rules
        mustAgreeToRules
        ignoreBookInAdvanceForStaff
        needsApproval
        weeklyReservationLimit
        isVisible
        isOnboardingOnly
        requiresPayment
        depositPrice
        hourlyPrice
        amenityType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenitysByBuilding = /* GraphQL */ `
  query ListAmenitysByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenitysByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resourceId
        buildingId
        label
        description
        rules
        mustAgreeToRules
        ignoreBookInAdvanceForStaff
        needsApproval
        weeklyReservationLimit
        isVisible
        isOnboardingOnly
        requiresPayment
        depositPrice
        hourlyPrice
        amenityType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityLinksByParent = /* GraphQL */ `
  query ListAmenityLinksByParent(
    $parentAmenityId: ID
    $childAmenityId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityLinksByParent(
      parentAmenityId: $parentAmenityId
      childAmenityId: $childAmenityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentAmenityId
        childAmenityId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityLinksByChild = /* GraphQL */ `
  query ListAmenityLinksByChild(
    $childAmenityId: ID
    $parentAmenityId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityLinksByChild(
      childAmenityId: $childAmenityId
      parentAmenityId: $parentAmenityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentAmenityId
        childAmenityId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityLinkClosuresByClosure = /* GraphQL */ `
  query ListAmenityLinkClosuresByClosure(
    $closureId: ID
    $originClosureId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityLinkClosureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityLinkClosuresByClosure(
      closureId: $closureId
      originClosureId: $originClosureId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        closureId
        originClosureId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityLinkClosuresByOriginClosure = /* GraphQL */ `
  query ListAmenityLinkClosuresByOriginClosure(
    $originClosureId: ID
    $closureId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityLinkClosureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityLinkClosuresByOriginClosure(
      originClosureId: $originClosureId
      closureId: $closureId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        closureId
        originClosureId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityReservationsByAmenity = /* GraphQL */ `
  query ListAmenityReservationsByAmenity(
    $amenityId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityReservationsByAmenity(
      amenityId: $amenityId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reservationId
        amenityId
        buildingId
        residentId
        staffId
        title
        useCase
        startAt
        endAt
        partySize
        reservationState
        isSystemControlled
        createdAt
        updatedAt
        notes
        isOnboardingOnly
        originId
        paymentMethodId
        depositPaymentId
        bookingPaymentId
        depositCost
        hourlyCost
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityReservationsByStatus = /* GraphQL */ `
  query ListAmenityReservationsByStatus(
    $reservationState: ReservationState
    $startAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityReservationsByStatus(
      reservationState: $reservationState
      startAt: $startAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reservationId
        amenityId
        buildingId
        residentId
        staffId
        title
        useCase
        startAt
        endAt
        partySize
        reservationState
        isSystemControlled
        createdAt
        updatedAt
        notes
        isOnboardingOnly
        originId
        paymentMethodId
        depositPaymentId
        bookingPaymentId
        depositCost
        hourlyCost
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityReservationsByReservation = /* GraphQL */ `
  query ListAmenityReservationsByReservation(
    $reservationId: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityReservationsByReservation(
      reservationId: $reservationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reservationId
        amenityId
        buildingId
        residentId
        staffId
        title
        useCase
        startAt
        endAt
        partySize
        reservationState
        isSystemControlled
        createdAt
        updatedAt
        notes
        isOnboardingOnly
        originId
        paymentMethodId
        depositPaymentId
        bookingPaymentId
        depositCost
        hourlyCost
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityReservationsByOrigin = /* GraphQL */ `
  query ListAmenityReservationsByOrigin(
    $originId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityReservationsByOrigin(
      originId: $originId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reservationId
        amenityId
        buildingId
        residentId
        staffId
        title
        useCase
        startAt
        endAt
        partySize
        reservationState
        isSystemControlled
        createdAt
        updatedAt
        notes
        isOnboardingOnly
        originId
        paymentMethodId
        depositPaymentId
        bookingPaymentId
        depositCost
        hourlyCost
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityReservationsByResident = /* GraphQL */ `
  query ListAmenityReservationsByResident(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityReservationsByResident(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reservationId
        amenityId
        buildingId
        residentId
        staffId
        title
        useCase
        startAt
        endAt
        partySize
        reservationState
        isSystemControlled
        createdAt
        updatedAt
        notes
        isOnboardingOnly
        originId
        paymentMethodId
        depositPaymentId
        bookingPaymentId
        depositCost
        hourlyCost
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAmenityReservationsByBuilding = /* GraphQL */ `
  query ListAmenityReservationsByBuilding(
    $buildingId: ID
    $amenityId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAmenityReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAmenityReservationsByBuilding(
      buildingId: $buildingId
      amenityId: $amenityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reservationId
        amenityId
        buildingId
        residentId
        staffId
        title
        useCase
        startAt
        endAt
        partySize
        reservationState
        isSystemControlled
        createdAt
        updatedAt
        notes
        isOnboardingOnly
        originId
        paymentMethodId
        depositPaymentId
        bookingPaymentId
        depositCost
        hourlyCost
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingNudgesByResident = /* GraphQL */ `
  query ListBuildingNudgesByResident(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingNudgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingNudgesByResident(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        residentId
        type
        label
        triggeredAt
        expiredAt
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingNudgesByBuilding = /* GraphQL */ `
  query ListBuildingNudgesByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingNudgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingNudgesByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        residentId
        type
        label
        triggeredAt
        expiredAt
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingActionsByResident = /* GraphQL */ `
  query ListBuildingActionsByResident(
    $residentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingActionsByResident(
      residentId: $residentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        residentId
        staffId
        buildingNudgeId
        cost
        reason
        notes
        actions
        actionTakenAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingActionsByBuilding = /* GraphQL */ `
  query ListBuildingActionsByBuilding(
    $buildingId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingActionsByBuilding(
      buildingId: $buildingId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        residentId
        staffId
        buildingNudgeId
        cost
        reason
        notes
        actions
        actionTakenAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listBuildingActionsByBuildingNudge = /* GraphQL */ `
  query ListBuildingActionsByBuildingNudge(
    $buildingNudgeId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingActionsByBuildingNudge(
      buildingNudgeId: $buildingNudgeId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        residentId
        staffId
        buildingNudgeId
        cost
        reason
        notes
        actions
        actionTakenAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorServicesByForeignService = /* GraphQL */ `
  query ListVendorServicesByForeignService(
    $foreignServiceId: ID
    $buildingId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServicesByForeignService(
      foreignServiceId: $foreignServiceId
      buildingId: $buildingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        foreignServiceId
        buildingId
        label
        type
        subType
        price
        duration
        amenityId
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorServicesByBuilding = /* GraphQL */ `
  query ListVendorServicesByBuilding(
    $buildingId: ID
    $typeSubType: ModelVendorServiceByBuildingCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServicesByBuilding(
      buildingId: $buildingId
      typeSubType: $typeSubType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        foreignServiceId
        buildingId
        label
        type
        subType
        price
        duration
        amenityId
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorServiceCreditsByResident = /* GraphQL */ `
  query ListVendorServiceCreditsByResident(
    $residentId: ID
    $expiredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorServiceCreditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServiceCreditsByResident(
      residentId: $residentId
      expiredAt: $expiredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        category
        title
        description
        amount
        discountType
        expiredAt
        vendorServiceTypes
        notes
        staffId
        vendorAppointmentId
        vendorServicePromotionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorServiceCreditsByVendorAppointment = /* GraphQL */ `
  query ListVendorServiceCreditsByVendorAppointment(
    $vendorAppointmentId: ID
    $expiredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorServiceCreditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServiceCreditsByVendorAppointment(
      vendorAppointmentId: $vendorAppointmentId
      expiredAt: $expiredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        category
        title
        description
        amount
        discountType
        expiredAt
        vendorServiceTypes
        notes
        staffId
        vendorAppointmentId
        vendorServicePromotionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorServiceCreditsByVendorServicePromotion = /* GraphQL */ `
  query ListVendorServiceCreditsByVendorServicePromotion(
    $vendorServicePromotionId: ID
    $expiredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorServiceCreditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServiceCreditsByVendorServicePromotion(
      vendorServicePromotionId: $vendorServicePromotionId
      expiredAt: $expiredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        residentId
        category
        title
        description
        amount
        discountType
        expiredAt
        vendorServiceTypes
        notes
        staffId
        vendorAppointmentId
        vendorServicePromotionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorServicePromotionsByBuilding = /* GraphQL */ `
  query ListVendorServicePromotionsByBuilding(
    $buildingId: ID
    $expiredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorServicePromotionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorServicePromotionsByBuilding(
      buildingId: $buildingId
      expiredAt: $expiredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        buildingId
        title
        description
        amount
        discountType
        startedAt
        expiredAt
        vendorServiceTypes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorAppointmentsByForeignAppointment = /* GraphQL */ `
  query ListVendorAppointmentsByForeignAppointment(
    $foreignAppointmentId: ID
    $startAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorAppointmentsByForeignAppointment(
      foreignAppointmentId: $foreignAppointmentId
      startAt: $startAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        foreignAppointmentId
        buildingId
        unitId
        residentId
        status
        reminderSentAt
        startAt
        endAt
        notes
        cost
        paymentMethodId
        paymentId
        amenityReservationId
        recurringVendorAppointmentId
        yardiBatchId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorAppointmentsByStatus = /* GraphQL */ `
  query ListVendorAppointmentsByStatus(
    $status: ReservationState
    $startAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorAppointmentsByStatus(
      status: $status
      startAt: $startAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        foreignAppointmentId
        buildingId
        unitId
        residentId
        status
        reminderSentAt
        startAt
        endAt
        notes
        cost
        paymentMethodId
        paymentId
        amenityReservationId
        recurringVendorAppointmentId
        yardiBatchId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorAppointmentsByResident = /* GraphQL */ `
  query ListVendorAppointmentsByResident(
    $residentId: ID
    $startAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorAppointmentsByResident(
      residentId: $residentId
      startAt: $startAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        foreignAppointmentId
        buildingId
        unitId
        residentId
        status
        reminderSentAt
        startAt
        endAt
        notes
        cost
        paymentMethodId
        paymentId
        amenityReservationId
        recurringVendorAppointmentId
        yardiBatchId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorAppointmentsByBuilding = /* GraphQL */ `
  query ListVendorAppointmentsByBuilding(
    $buildingId: ID
    $startAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorAppointmentsByBuilding(
      buildingId: $buildingId
      startAt: $startAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        foreignAppointmentId
        buildingId
        unitId
        residentId
        status
        reminderSentAt
        startAt
        endAt
        notes
        cost
        paymentMethodId
        paymentId
        amenityReservationId
        recurringVendorAppointmentId
        yardiBatchId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listVendorAppointmentsByVendorService = /* GraphQL */ `
  query ListVendorAppointmentsByVendorService(
    $vendorServiceId: ID
    $startAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorAppointmentsByVendorService(
      vendorServiceId: $vendorServiceId
      startAt: $startAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        foreignAppointmentId
        buildingId
        unitId
        residentId
        status
        reminderSentAt
        startAt
        endAt
        notes
        cost
        paymentMethodId
        paymentId
        amenityReservationId
        recurringVendorAppointmentId
        yardiBatchId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecurringVendorAppointmentsByResident = /* GraphQL */ `
  query ListRecurringVendorAppointmentsByResident(
    $residentId: ID
    $lastOccurredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecurringVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecurringVendorAppointmentsByResident(
      residentId: $residentId
      lastOccurredAt: $lastOccurredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        buildingId
        unitId
        residentId
        paymentMethodId
        frequency
        notes
        metaPetProfileIds
        firstOccurredAt
        lastOccurredAt
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecurringVendorAppointmentsByBuilding = /* GraphQL */ `
  query ListRecurringVendorAppointmentsByBuilding(
    $buildingId: ID
    $lastOccurredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecurringVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecurringVendorAppointmentsByBuilding(
      buildingId: $buildingId
      lastOccurredAt: $lastOccurredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        buildingId
        unitId
        residentId
        paymentMethodId
        frequency
        notes
        metaPetProfileIds
        firstOccurredAt
        lastOccurredAt
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecurringVendorAppointmentsByVendorService = /* GraphQL */ `
  query ListRecurringVendorAppointmentsByVendorService(
    $vendorServiceId: ID
    $lastOccurredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecurringVendorAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecurringVendorAppointmentsByVendorService(
      vendorServiceId: $vendorServiceId
      lastOccurredAt: $lastOccurredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vendorServiceId
        buildingId
        unitId
        residentId
        paymentMethodId
        frequency
        notes
        metaPetProfileIds
        firstOccurredAt
        lastOccurredAt
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchChatMessages = /* GraphQL */ `
  query SearchChatMessages(
    $filter: SearchableChatMessageFilterInput
    $sort: SearchableChatMessageSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchChatMessages(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        chatRoomId
        chatParticipantId
        content
        isAttachments
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const searchStaffNotes = /* GraphQL */ `
  query SearchStaffNotes(
    $filter: SearchableStaffNoteFilterInput
    $sort: SearchableStaffNoteSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchStaffNotes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        buildingId
        staffId
        content
        createdAt
        updatedAt
        isDeleted
        isPinned
        isSticky
        staffNoteId
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const searchMessages = /* GraphQL */ `
  query SearchMessages(
    $filter: SearchableMessageFilterInput
    $sort: SearchableMessageSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchMessages(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        createdAt
        messageConversationId
        messageStaffId
        recipient
        body
        type
        topic
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
